import React from 'react';
import { CheckCircle } from 'lucide-react';
export function Bonuses() {
  const achievements = ['Mostrar trabajos mucho más premium', 'Cobrar mejor por tus diseños', 'Ahorrar tiempo buscando ideas', 'Diferenciarte de otros talleres', 'Tener diseños modernos siempre listos'];
  return <section className="py-7 md:py-12 px-3 bg-brand-dark" data-id="element-16">
      <div className="max-w-2xl mx-auto text-center" data-id="element-17">
        <h2 className="text-xl md:text-4xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-18">
          🚀 ¿QUÉ VAS A LOGRAR?
        </h2>

        <div className="bg-brand-card rounded-xl p-4 md:p-8 border border-white/10 shadow-2xl" data-id="element-19">
          <div className="space-y-3 md:space-y-4 text-left max-w-lg mx-auto" data-id="element-20">
            {achievements.map((item, i) => <div key={i} className="flex items-start" data-id="element-21">
                <div className="bg-brand-accent text-brand-dark rounded-full p-0.5 mr-3 shrink-0 mt-0.5" data-id="element-22">
                  <CheckCircle className="w-4 h-4 md:w-6 md:h-6" data-id="element-23" />
                </div>
                <p className="text-sm md:text-xl font-black text-white leading-snug" data-id="element-24">
                  {item}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}